export interface PaymentMethods {
  id: number;
  paymentMode: string;
  court: string;
  totalLimit: number;
  remainingLimit: number | null;
  paymentPortalPaymentTypes: string[];
  icon?: string;
  label?: string;
  description?: string | null;
}

export enum PaymentMode {
  PAY_NOW = 'PAY_NOW',
  CHEQUE = 'CHEQUE',
  CREDIT_CARD = 'CREDIT_CARD'
}

export const PaymentModeMapping: Record<string, { label: string; codes: string[] }> = {
  PAY_NOW: { label: 'PAY_NOW', codes: ['PAY_NOW'] },
  CHEQUE: { label: 'CHEQUE', codes: ['CHEQUE'] },
  CREDIT_CARD: { label: 'CREDIT_CARD', codes: ['CREDIT_CARD', 'CRDF', 'CRD_UNKNOWN'] }, // <-- both codes map here
};

export enum PacRefSearch {
  COURT_DEPOSIT = 'COURT_DEPOSIT',
  COURT_PAYMENT = 'COURT_PAYMENT'
}


const otherPayments = ['CAR_PARK_REQUEST', 'RENTAL_UTILITY_REQUEST', 'MANUAL_INVOICE', 'MISCELLANEOUS', 'BILLING_AGENCY', 'SJC', 'COURT_DEPOSITS', 'SHERIFF_BAILIFF_DEPOSIT', 'OTHER_DEPOSIT', 'SICC', 'SID', 'OTHER_PAYMENTS'];

export const PaymentTypeMapping: Record<string, string> = {
  COURT_FEE: 'Court Fees',
  COURT_FINE: 'Court Fines',
  BAIL_ORDER: 'Bail/Bond',
  ...Object.fromEntries(otherPayments.map(code => [code, 'Other Payments'])),
};


